var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOfficeBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.1999 3.20001C3.1999 2.77566 3.36847 2.36869 3.66853 2.06864C3.96859 1.76858 4.37556 1.60001 4.7999 1.60001H11.1999C11.6242 1.60001 12.0312 1.76858 12.3313 2.06864C12.6313 2.36869 12.7999 2.77566 12.7999 3.20001V12.8C13.0121 12.8 13.2156 12.8843 13.3656 13.0343C13.5156 13.1843 13.5999 13.3878 13.5999 13.6C13.5999 13.8122 13.5156 14.0157 13.3656 14.1657C13.2156 14.3157 13.0121 14.4 12.7999 14.4H10.3999C10.1877 14.4 9.98425 14.3157 9.83422 14.1657C9.68419 14.0157 9.5999 13.8122 9.5999 13.6V12C9.5999 11.7878 9.51562 11.5843 9.36559 11.4343C9.21556 11.2843 9.01208 11.2 8.7999 11.2H7.1999C6.98773 11.2 6.78425 11.2843 6.63422 11.4343C6.48419 11.5843 6.3999 11.7878 6.3999 12V13.6C6.3999 13.8122 6.31562 14.0157 6.16559 14.1657C6.01556 14.3157 5.81208 14.4 5.5999 14.4H3.1999C2.98773 14.4 2.78425 14.3157 2.63422 14.1657C2.48419 14.0157 2.3999 13.8122 2.3999 13.6C2.3999 13.3878 2.48419 13.1843 2.63422 13.0343C2.78425 12.8843 2.98773 12.8 3.1999 12.8V3.20001ZM5.5999 4.00001H7.1999V5.60001H5.5999V4.00001ZM7.1999 7.20001H5.5999V8.80001H7.1999V7.20001ZM8.7999 4.00001H10.3999V5.60001H8.7999V4.00001ZM10.3999 7.20001H8.7999V8.80001H10.3999V7.20001Z",
    fill: "#09090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfficeBuilding);
export default __webpack_public_path__ + "static/media/OfficeBuilding.fc61128856423acc8d3b3cb3ee26b406.svg";
export { ForwardRef as ReactComponent };